import { useEffect, useState } from "react"


export default function useBalanceUpdate(
    stateRound: {
      balance: string
      balancebefore: string
      totalWin: string
    },
    showResult: boolean,
  ): string {
    const [finalBalance, setFinalBalance] = useState<string>(stateRound.balance)
    const [afterBalance, setAfterBalance] = useState<string>(stateRound.balance)
    const [beforeBalance, setBeforeBalance] = useState<string>(
      stateRound.balancebefore,
    )
  
    useEffect(() => {
      setFinalBalance(stateRound.balance)
    }, [stateRound.balance])
  
    useEffect(() => {
      setAfterBalance(stateRound.balance)
      setBeforeBalance(stateRound.balancebefore)
    }, [stateRound])
  
    useEffect(() => {
      if (+stateRound.totalWin > 0) {
        setFinalBalance(beforeBalance)
      } else {
        setFinalBalance(afterBalance)
      }
    }, [afterBalance, beforeBalance])
  
    useEffect(() => {
      setFinalBalance(afterBalance)
    }, [showResult])
  
    return finalBalance 
}